import React, { useCallback, useEffect, useState, useContext } from 'react'
import { t } from "i18next";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
  } from "react-device-detect";
import PageHeader from "../../components/PageHeader";
import TabContainer from '../../components/TabContainer/TabContainer';
import SettingTab from './SettingsTab';
import PreferenceSettings from './PreferenceSetting/PreferenceSetting';
import ProfileSettings from './ProfileSettings/ProfileSettings';
import AvailableResource from './AvailableResource/AvailableResource';
import {
  userProfile,
  getSignatureImage,
  userPreference
} from "../../service/UserService";
import userContext from '../../context/users/UserContext';
import ChangePassword from '../ChangePassword/ChangePassword';
import { USERTYPES } from '../../constants/Constants';
import loaderContext from '../../context/loader/LoaderContext';
import ContactDetails from './ContactDetails/ContactDetails';
import ActiveSessions from './ActiveSessions';
import { useLocation } from 'react-router-dom';


const AccountAndSettings = () => {
    const [totalTabs, setTotalTabs] = useState(2);
    
  const [showPreferenceTab, setShowPreferenceTab] = useState(false);
  const [contactDetailsData, setContactDetailsData] = useState({});
  const[showContactDetailsTab, setShowContactDetailsTab] = useState(false);
    
    const { roles, authenticated, loadByUsername, userId } = useContext(userContext);
    const {ref, setLoaderRunning} = useContext(loaderContext);
    const [selectedKey, setSelectedKey] = useState("1");

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tabParam = params.get("tab");

    const [defaultTab, setDefaultTab] = useState(tabParam === "active-logins" ? 3 : 1);


    const tabDetails = () =>{

    let items = [
        {
          selectedKey: "1",
          tabName: `${t("account-and-settings.profile")}`,
          tabKeyContain: (
            <SettingTab
              tabName={t("account-and-settings.profile")}
              subtitle={t("sub-title.user.profile-settings")}
            />
          ),
          tabValueContain:
            <ProfileSettings key="1"
            />
        },
        {  selectedKey: "2",
          tabName: `${t("account-and-settings.password")}`,
          tabKeyContain: (
            <SettingTab
              tabName={t("account-and-settings.password")}
              subtitle={t("sub-title.user.password-setting")}
            />
          ),
          tabValueContain:
            <ChangePassword key="2" />
        },
        {
          selectedKey: "3",
          tabName: `${t("account-and-settings.active-logins")}`,
          tabKeyContain: (
            <SettingTab
              tabName={t("account-and-settings.active-logins")}
              subtitle={t("sub-title.user.active-logins")}
            />
          ),
          tabValueContain: (
            <ActiveSessions key="3" /> // force re-mount
          )
        }
    ]
    
    if(showPreferenceTab){
      items.push({
        selectedKey: "4",
        tabName: `${t("account-and-settings.preference")}`,
        tabKeyContain: (
          <SettingTab
            tabName={t("account-and-settings.preference")}
            subtitle={t("sub-title.user.viewer-preference")}
          />
        ),
        tabValueContain:
          <PreferenceSettings key="4"
            loggedInUserId= {userId}
            loggedInUserRole= {roles[0]}
          />
      })
      }
      if(showContactDetailsTab){
        items.push({
          selectedKey: showPreferenceTab ? "5" : "4",
          tabName: `${t("account-and-settings.contact-details")}`,
          tabKeyContain: (
            <SettingTab
              tabName={t("account-and-settings.contact-details")}
              subtitle={t("sub-title.user.contact-details")}
            />
          ),
          tabValueContain:
            <ContactDetails key="5"
            // contactDetailsData={contactDetailsData}
            // loggedInUserId= {userId}
            // loggedInUserRole= {roles[0]} 
            />
        })
      }

    //  items.push({
    //   selectedKey: "5",
    //   tabName: `${t("account-and-settings.active-logins")}`,
    //   tabKeyContain: (
    //     <SettingTab
    //       tabName={t("account-and-settings.active-logins")}
    //       subtitle={t("sub-title.user.active-logins")}
    //     />
    //   ),
    //   tabValueContain: (
    //     <ActiveSessions key={`active-${Date.now()}`} /> // force re-mount
    //   ),
    // });

    return items;
  }

  const handleTabs = () => {
    if (roles[0] == USERTYPES.TYPIST || roles[0] == USERTYPES.RADIOLOGIST || roles[0] == USERTYPES.FIRMADMIN || roles[0] == USERTYPES.SUPERVISOR || roles[0] == USERTYPES.ADMIN ) {
      setShowPreferenceTab(true);
      setShowContactDetailsTab(false);
      setTotalTabs(3);
      
    }
    else if (roles[0] == USERTYPES.FIRMDOCTOR  || roles[0] == USERTYPES.FIRMTECHNICIAN) {
      setShowPreferenceTab(true);
      setShowContactDetailsTab(true);
      setTotalTabs(4);
    }
    else if (roles[0] == USERTYPES.FIRMTECHNICIAN) {
      setShowPreferenceTab(true);
      setShowContactDetailsTab(true);
      setTotalTabs(4);
    }
    else {
        setShowPreferenceTab(false);
        setShowContactDetailsTab(true);
        setTotalTabs(3);
    }
  }

  // const getUserProfile = async () => {
  //   let response = await userProfile();
  //   if (response.status === 200 && response.data.result === "SUCCESS") {
  //     setContactDetailsData(response.data.data);
  //     console.log("contactDetailsData in AccountsAndSettings.jsx : ", contactDetailsData);
  //     // setValues({
  //     //   ...response.data.data,
  //     //   technicianContactList: response.data.data.technicianContactList,
  //     // });
  //   }
  // };




    useEffect(() => {
      if (!authenticated) {
        loadByUsername();
      }
    }, []);

    useEffect(()=>{
      handleTabs();
    }, [roles]);

    console.log("---tabDetails ---",tabDetails());

    return (
        <>
                <div className="main-container-body">
                    {!isMobile && <PageHeader header="account-and-settings.title" />}
                    {/* <div style={{ height: !isMobile ? '92%' : '100%' }}> */}
                    <TabContainer
                    uniqueKey="acnt&stng_"
                    tabDetails={tabDetails()}
                    NoOfTabs={tabDetails()?.length}
                    defaultSelectedValue={defaultTab.toString()}
                    onCancelClick={()=>{"on cancel click"}}
                    onSubmitClick={()=>{"on submit click"}}
                    onNextClick={()=>{"on next click"}}
                    onEditClick={()=>{"on edit click"}}
                    previousNextButton={false}
                    mobileTabHeader={t("account-and-settings.title")}
                    //breadCrumbItems = {breadCrumbItems}
                    // topButtons = {[]}
                    />
                </div>
                
            
        </>
    )

}

export default AccountAndSettings
